/** Analytics plan_slug closed set (events.md / spec §3.3). Never Basico-default unknowns (BR-19). */
export type AnalyticsPlanSlug = "Free" | "Basico" | "Pro" | "Clinic" | "other";

/**
 * Normalize a raw plan identifier for PostHog identify/events.
 * Unknown / empty → omit (`undefined`) or `other` — never coerce to Basico.
 */
export function resolveAnalyticsPlanSlug(raw: string | null | undefined): AnalyticsPlanSlug | undefined {
  if (!raw?.trim()) {
    return undefined;
  }

  const trimmed = raw.trim();
  const lower = trimmed.toLowerCase();

  if (trimmed === "Free" || lower === "gratuito" || lower === "freemium" || lower === "free") {
    return "Free";
  }

  if (
    trimmed === "Basico" ||
    lower === "básico" ||
    lower === "basico" ||
    lower === "basic"
  ) {
    return "Basico";
  }

  if (
    trimmed === "Pro" ||
    lower === "pro" ||
    lower === "proplus" ||
    lower === "pro+" ||
    lower === "professional_30" ||
    lower === "professional_50"
  ) {
    return "Pro";
  }

  if (
    trimmed === "Clinic" ||
    lower === "clinic" ||
    lower === "clínica" ||
    lower === "clinica" ||
    lower === "multi"
  ) {
    return "Clinic";
  }

  if (trimmed === "other" || lower === "other") {
    return "other";
  }

  return "other";
}
